<template>
  <div class="py-3">
    <v-card class="pa-5 rounded-lg" flat>
      <div>
        <div class="d-flex align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="$router.go(-1)"
                color="#006341"
                icon
                ><v-icon>mdi-reply</v-icon></v-btn
              >
            </template>
            <span>Back</span>
          </v-tooltip>
          <h3>TSA Activity</h3>
        </div>
        <p class="medium_txt mt-2">
          TSA can submit proposals in this page. There are 5 type of proposal
          that you can propose.
        </p>
      </div>
    </v-card>
    <v-card class="pa-5 mt-3 rounded-lg" flat>
      <div class="d-flex align-start">
        <v-icon class="mr-2" color="rgba(0, 99, 65, 0.5)">
          mdi-alert-circle
        </v-icon>
        <div>
          <p class="medium_txt">Type of Proposal:</p>
          <div
            class="d-flex align-start"
            v-for="(item, n) in activityProposal"
            :key="n"
          >
            <p class="mr-2 medium_txt">{{ item.no }}.</p>
            <p class="medium_txt">
              {{ item.text }}
            </p>
          </div>
        </div>
      </div>
    </v-card>

    <v-card v-if="!loading" class="pa-5 mt-3 rounded-lg" flat>
      <div class="d-flex align-start">
        <v-icon class="mr-2" color="rgba(0, 99, 65, 0.5)">
          mdi-tray-arrow-up
        </v-icon>
        <div>
          <h3>Submit Your Proposal</h3>
          <div class="mt-2">
            <h4>Please follow below instructions:</h4>
            <v-row no-gutters>
              <v-col cols="12" md="4" class="pa-2">
                <h2>1</h2>
                <div class="d-flex flex-column align-center justify-center">
                  <div style="height: 18vh; width: 80%; display: flex">
                    <v-img
                      class="my-2"
                      src="../../../../assets/img/proposal/step1.png"
                      width="100%"
                      contain
                      alt="John"
                    />
                  </div>
                  <p style="text-align: center">
                    Download and read the guideline
                  </p>
                </div>
              </v-col>

              <v-col cols="12" md="4" class="pa-2">
                <h2>2</h2>
                <div class="d-flex flex-column align-center justify-center">
                  <div style="height: 18vh; width: 80%; display: flex">
                    <v-img
                      class="my-2"
                      src="../../../../assets/img/proposal/step3.png"
                      width="100%"
                      contain
                      alt="John"
                    />
                  </div>
                  <p style="text-align: center">
                    Submit your proposal and fill in necessary data
                  </p>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pa-2">
                <h2>3</h2>
                <div class="d-flex flex-column align-center justify-center">
                  <div style="height: 18vh; width: 80%; display: flex">
                    <v-img
                      class="my-2"
                      src="../../../../assets/img/proposal/step4.png"
                      width="100%"
                      contain
                      alt="John"
                    />
                  </div>

                  <p style="text-align: center">
                    You can monitor your proposal progress in this platform
                  </p>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="mt-2">
            <v-btn class="btn" @click="createProposal" color="#006341" dark>
              Submit</v-btn
            >
          </div>
        </div>
      </div>
    </v-card>
    <div v-if="!loading && dataSet">
      <v-card v-if="dataSet.length" class="pa-5 mt-3 rounded-lg" flat>
        <div class="d-flex align-start">
          <v-icon class="mr-2" color="rgba(0, 99, 65, 0.5)">
            mdi-format-list-bulleted-square
          </v-icon>
          <h3>List Submitted Proposal</h3>
        </div>
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 mt-2 color_txt"
          hide-default-footer
          :single-select="false"
          :item-class="row_classes"
        >
          <template v-slot:[`item.start_date`]="{ item }">
            <div class="d-flex align-center">
              <p class="pa-0 ma-0">
                {{ $date(item.start_date).format("MM/DD/YYYY") }}
              </p>
            </div>
          </template>
          <template v-slot:[`item.progress`]="{ item }">
            <div class="d-flex pa-1">
              <v-card
                v-if="item.progress"
                flat
                class="pa-1 px-3 rounded-xl"
                :color="
                  item.progress == 'Proposal approved' ||
                  item.progress == 'Letter approved'
                    ? '#006341'
                    : '#B3A369'
                "
              >
                <h4
                  style="
                    color: white;
                    text-transform: uppercase;
                    text-align: center;
                  "
                >
                  {{ item.progress }}
                </h4>
              </v-card>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn
                class="mr-2"
                icon
                :to="`/scholar/tsa/proposal-tsa/${item.id}`"
              >
                <v-icon color="#000000">mdi-eye</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <div class="text-center my-2 pa-3" v-if="dataSet">
          <v-pagination
            v-model="page"
            color="#006341"
            @input="fetchData"
            :length="last_page"
          ></v-pagination>
        </div>
      </v-card>
    </div>
    <div v-if="loading">
      <v-card flat class="mt-5 pa-5 rounded-lg" v-for="(item, i) in 2" :key="i">
        <v-skeleton-loader
          type="list-item-two-line, article"
        ></v-skeleton-loader>
      </v-card>
    </div>

    <div class="pa-3">
      <create-tsa-register-scholar
        :d_tsa="d_tsa"
        @refetch="fetchProfile"
        @close="d_tsa = false"
        :inventory="inventory"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
import createTsaRegisterScholar from "./createTsaRegisterScholar.vue";
export default {
  components: { createTsaRegisterScholar },
  name: "tsaProposalSchoalr",
  computed: {
    ...mapState({
      profile: (state) => state.profile,
    }),
  },
  data() {
    return {
      activityProposal: [
        {
          no: 1,
          text: "Handover TSA",
        },
        {
          no: 2,
          text: "Internal Project",
        },
        {
          no: 3,
          text: "Pay It Forward",
        },
        {
          no: 4,
          text: "Special Webinars",
        },
        {
          no: 5,
          text: "Mini Project",
        },
      ],
      headers: [
        {
          text: "TITLE",
          align: "start",
          value: "title",
          sortable: false,
        },
        {
          text: "TYPE",
          align: "start",
          value: "category.name",
          sortable: false,
        },
        {
          text: "Execution Date",
          align: "start",
          value: "start_date",
        },
        {
          text: "Progress",
          align: "start",
          value: "progress",
        },
        {
          text: "ACTION",
          align: "start",
          value: "actions",
          sortable: false,
        },
      ],
      d_type: "",
      d_title: "",
      d_tsa: false,
      hide_title: "",
      btnTitle: "",
      d_title2: "",
      txtTambahan: "",
      dataSet: null,
      total: 1,
      last_page: 1,
      inventory: "",
      loading: true,
      page: 1,
      limit: 10,
      find: "",
      optTypeEvent: null,
    };
  },
  mounted() {
    this.fetchProfile();
  },
  methods: {
    fetchProfile() {
      this.loading = true;
      let data = {
        path: `scholar?scholar_id=${Cookies.get("scholar")}`,
      };
      this.$store.dispatch("course/getData", data).then((data) => {
        this.fetchData(data.university_id);
      });
    },

    fetchData(tsa) {
      this.loading = true;
      let data = {
        path: `scholar/tsa-proposal/register?filter[title]=${this.find}&filter[tsa_id]=${tsa}&include=category`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    createProposal() {
      this.d_title = "Register For An Event";
      this.d_tsa = true;
    },

    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>

<style></style>
